import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["documentBtn", "mapBtn", "documentView", "mapView"]

  static values = {
    currentView: { type: String, default: "document" }
  }

  connect() {
    // Initialize view toggle controller
  }

  showDocument() {
    this.currentViewValue = "document"
    this.updateView()
  }

  showMap() {
    this.currentViewValue = "map"
    this.updateView()
  }

  updateView() {
    const isDocument = this.currentViewValue === "document"

    // Update button styles
    if (this.hasDocumentBtnTarget) {
      if (isDocument) {
        this.documentBtnTarget.classList.remove("bg-white", "text-[#6b7280]", "rounded-lg")
        this.documentBtnTarget.classList.add("bg-[#f2f3f5]", "text-[#1f2937]", "rounded-md")
      } else {
        this.documentBtnTarget.classList.add("bg-white", "text-[#6b7280]", "rounded-lg")
        this.documentBtnTarget.classList.remove("bg-[#f2f3f5]", "text-[#1f2937]", "rounded-md")
      }
    }

    if (this.hasMapBtnTarget) {
      if (!isDocument) {
        this.mapBtnTarget.classList.remove("bg-white", "text-[#6b7280]", "rounded-lg")
        this.mapBtnTarget.classList.add("bg-[#f2f3f5]", "text-[#1f2937]", "rounded-md")
      } else {
        this.mapBtnTarget.classList.add("bg-white", "text-[#6b7280]", "rounded-lg")
        this.mapBtnTarget.classList.remove("bg-[#f2f3f5]", "text-[#1f2937]", "rounded-md")
      }
    }

    // Update view visibility
    if (this.hasDocumentViewTarget) {
      this.documentViewTarget.classList.toggle("hidden", !isDocument)
    }

    if (this.hasMapViewTarget) {
      this.mapViewTarget.classList.toggle("hidden", isDocument)
    }

    // Dispatch the view change for any sibling controllers.
    this.dispatch("viewChanged", { detail: { currentView: this.currentViewValue } })
  }
}
